import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { StateService } from "@zp-services/state.service";
import { Subscription } from "rxjs";
import { Question } from "../../models/question";
import { ReceiptComponent } from "../receipt/receipt.component";

@Component({
  imports: [RouterOutlet, TranslateModule, ReceiptComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: "app-question-wizard",
  templateUrl: "./question-wizard.component.html",
  styleUrls: ["./question-wizard.component.css"],
})
export class QuestionWizardComponent implements OnInit, OnDestroy {
  hasAnswers = false;
  isAdvicePage = false;

  private subscription?: Subscription;
  private stepsConfig!: Record<string, Question>;
  private firstStepId!: string;

  constructor(
    private stateService: StateService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.stepsConfig = this.stateService.getQuestionWizardStepsConfig();
    this.firstStepId = Object.keys(this.stepsConfig)[0];

    this.isAdvicePage = this.router.url.includes("advies");

    this.subscription = this.stateService.answers$.subscribe((answers) => {
      this.hasAnswers = Object.keys(answers).length > 0;
    });

    if (!this.hasAnyData() && !this.isCurrentlyOnStep()) {
      this.redirectToFirstStep();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /** Checkt of er al data aanwezig is */
  private hasAnyData(): boolean {
    const answers = this.stateService.getAnswers();
    return Object.values(answers).some(
      (stepData) => stepData && Object.values(stepData).some((v) => v !== null && v !== "")
    );
  }

  /** Checkt of huidige URL op een bestaande stap zit */
  private isCurrentlyOnStep(): boolean {
    const currentStepId =
      this.route.firstChild?.snapshot.paramMap.get("stepId") ||
      this.route.firstChild?.snapshot.url[0]?.path;

    return !!currentStepId && currentStepId in this.stepsConfig;
  }

  /** Navigeer naar de eerste stap */
  private redirectToFirstStep(): void {
    this.router.navigate([this.firstStepId], { relativeTo: this.route });
  }
}
